import { useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'
import { ContentBox } from '@/shared/ui'
import { RefundTermNotice, useRefundTerm } from '@/widgets/contract-detail'

import { Heading, Item, List } from '../common'

type Props = Pick<TRoomDetail, 'refundTerms'> & {
  isOldRefundTerms?: boolean
}

export const MobileRefundTerm = ({
  refundTerms,
  isOldRefundTerms = false,
}: Props) => {
  const t = useTranslations()
  const { getDiffDayText, getPenaltyText } = useRefundTerm()

  return (
    <section className="px-4 py-10">
      <Heading size="small" className="mb-4">
        {t('room_detail.refund_policy.title')}
      </Heading>

      <div>
        <div className="typo-label2 mb-3 flex items-center justify-between font-medium text-gray-500">
          <span>{t('refund_policy.label.cancel_date')}</span>
          <span>{t('refund_policy.label.penalty')}</span>
        </div>

        <List
          spacing="xSmall"
          variant="dashed"
          borderColor="gray"
          className="mb-5"
        >
          {refundTerms.map(refundTerm => (
            <Item
              key={refundTerm.beforeCheckinDays}
              className="typo-label2 flex items-center justify-between gap-2 font-normal text-gray-900"
            >
              <span className="max-w-[40%]">
                {getDiffDayText(refundTerm.beforeCheckinDays)}
              </span>
              <span className="text-end">
                {getPenaltyText(refundTerm.cancelFeePercent, isOldRefundTerms)}
              </span>
            </Item>
          ))}
        </List>

        <ContentBox color="light-gray" spacing="medium" className="py-5">
          <RefundTermNotice
            isOldRefundTerms={isOldRefundTerms}
            className="px-0"
            titleClassName="mb-2"
            listClassName="space-y-3"
          />
        </ContentBox>
      </div>
    </section>
  )
}
